<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header title="客户后付费明细" />
    </div>

    <div class="jc-page-content">
      <div class="jc-page-card">
        <div class="jc-container-table">
          <div class="jc-container-table-actionBar">
            <el-form
              class="jc-table-actionBar-item"
              :inline="true"
              :model="form"
            >
              <el-form-item label="PIN：">
                <el-input v-model.trim="form.customerPin"></el-input>
              </el-form-item>

              <el-form-item label="账号名：">
                <el-input v-model.trim="form.loginName"></el-input>
              </el-form-item>

              <el-form-item label="支付时间：">
                <el-date-picker
                  v-model="daterange"
                  :clearable="false"
                  type="daterange"
                  placeholder="选择日期范围"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="query(query)">查询</el-button>
              </el-form-item>

              <el-form-item>
                <el-button @click="exportList" class="jc-button-icon"
                  ><i class="jc-icon-download"></i>
                </el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table :data="tableData" style="width: 100%" class="form-loading">
            <el-table-column prop="pin" label="PIN">
              <template slot-scope="scope">{{
                scope.row.pin | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="loginName" label="账号名">
              <template slot-scope="scope">{{
                scope.row.loginName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="客户名称">
              <template slot-scope="scope">{{
                scope.row.realName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="产品名称">
              <template slot-scope="scope">{{
                scope.row.serviceCodeName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="消费金额(元)">
              <template slot-scope="scope">{{
                scope.row.consumeCount | formatMoney
              }}</template>
            </el-table-column>

            <el-table-column label="现金支付(元)">
              <template slot-scope="scope">{{
                scope.row.cashPayFeeCount | formatMoney
              }}</template>
            </el-table-column>

            <el-table-column>
              <template slot="header">
                免费代金券(元)
                <el-tooltip
                  content="免费代金券不计入销售业绩"
                  placement="top-end"
                >
                  <i class="jc-icon-my-help"></i>
                </el-tooltip>
              </template>

              <template slot-scope="scope">{{
                scope.row.freeCouponFeeCount | formatMoney
              }}</template>
            </el-table-column>

            <el-table-column label="付费代金券(元)">
              <template slot-scope="scope">{{
                scope.row.payCouponFeeCount | formatMoney
              }}</template>
            </el-table-column>

            <el-table-column label="计入业绩金额(元)">
              <template slot-scope="scope">{{
                scope.row.achievmentCount | formatMoney
              }}</template>
            </el-table-column>
          </el-table>

          <div class="jc-container-table-actionBar" v-if="total > 10">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.pageIndex"
              :page-sizes="[10, 20, 50]"
              :page-size="form.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryCustPostFeeList,
  exportCustPostFeeList,
} from '@/api/distributor-api.js'
import { getDate } from '@/utils'
import routerMixins from '@/mixins/router-mixins.js'
import handlepageMixins from '@/mixins/handlepage-mixins.js'
export default {
  mixins: [routerMixins, handlepageMixins],
  data() {
    // 默认时间为当前月的1号到月底
    var timeDefaultStart = new Date().setDate(1)
    var timeDefaultEnd = new Date(timeDefaultStart)
    timeDefaultEnd.setMonth(timeDefaultEnd.getMonth() + 1)
    timeDefaultEnd.setDate(0)
    return {
      form: {
        pageSize: 10,
        pageIndex: 1,
        beginTime: getDate(new Date().setDate(1)).txt_ymd + ' 00:00:00',
        endTime: getDate(new Date()).txt_ymd + ' 23:59:59',
        customerPin: '',
        orderNo: '',
        loginName: '',
      },
      daterange: [timeDefaultStart, timeDefaultEnd],
      total: 0,
      tableData: [],
      queryFunction: queryCustPostFeeList,
      exportFunction: exportCustPostFeeList,
    }
  },
  watch: {
    daterange(curVal) {
      this.form.beginTime =
        (curVal[0] && getDate(curVal[0]).txt_ymd + ' 00:00:00') || ''
      this.form.endTime =
        (curVal[1] && getDate(curVal[1]).txt_ymd + ' 23:59:59') || ''
    },
  },
  created() {
    this.query()
  },
  methods: {},
}
</script>
